export default __webpack_public_path__ + "media/pngs/no-product-listview-78e76b17.png";